var render = function render(){var _vm=this,_c=_vm._self._c;return _c('step-container',_vm._g({attrs:{"required-data":_vm.requiredData,"data":_vm.data,"on-submit":_vm.submit,"has-steps":_vm.isOnboarding}},_vm.$listeners),[(_vm.isOnboarding)?_c('company-data',{attrs:{"data":_vm.data,"is-onboarding":""}}):_c('v-card',{attrs:{"flat":""}},[_c('company-data',{staticClass:"mx-4",attrs:{"data":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }